module.exports = __webpack_public_path__ + "static/media/MMTC-PAMP-offer.3e8d9d04.png";